export function scrollToUploads() {
    let headerHeight = $("header.header").height();
    let btnDistance;
    let indent = 40;

    $(".leadership-section").on("click", ".js-pagination", function () {
        btnDistance = Math.round($(this).offset().top);

        setTimeout(() => {
            $("html, body").animate({ scrollTop: btnDistance - headerHeight - indent });
        }, 600);
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/scrollToUploads.js